import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Inject, Input, DOCUMENT } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

@Component({
    selector: 'fc-search-input-animated',
    templateUrl: './fc-search-input-animated.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule
    ]
})
export class FcSearchInputAnimatedComponent {
  @Input({ required: true })
  public searchNameInputControl!: any

  @Input({ required: true })
  public placeholder!: string

  public showSearchNameInput = false

  public constructor(@Inject(DOCUMENT) public document: Document) { }
}
